<script>
    import pubsub from 'sweet-pubsub';
    import authStore from 'store/auth.js'
    import recieverStore from 'store/reciever';
    import messageStore from 'store/message.js'
    import Chat from '../../services/chat/chat.js';
    import Icon from '../../components/Icon.svelte';
    import { StreamChatProvider } from '../../services/chat/providers';
    import { useNavigate, useParams, useFocus } from 'svelte-navigator';
    import moment from 'moment';

    const registerFocus = useFocus();
    const navigate = useNavigate()
    const params = useParams()

    messageStore.set([])
    const chat = new Chat(new StreamChatProvider());
    const user = chat.user();
    chat.join({cid: $params.channel_id, userId: user.id}).then()
    
    const uploadFile = e => chat.sendImage(e)

    const download = (url) => {
        const filename = `PressOne-File-${moment().format('YYYY-MM-DD-h-mm')}`
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            link.click();
        })
        .catch(console.error);
    }

</script>

<div id="pannel">
    <div class="pannel-box">
        <div class="controls">
            <span>{ $params.channel_id }</span>
            <button on:click={() => navigate('/channels')}>list</button>
        </div>
        <div class="chat-container" id="chat-container">
            <ul class="chat">
                {#each $messageStore.messages as {message, user, attachments = [], status = {}, created_at}}
                    {#if `${user.id}`.split("-").pop() === `${$recieverStore.user.id}`}
                    <li class={`message right ${status.isSending ? 'sending' : ''} ${status.isFailed ? 'error' : ''}`}>
                        <img class="logo" src={user.image || chat.myAvatar()} alt="">
                        <p>
                            {#if attachments.length > 0}
                                {#each attachments as attachment}
                                    <img class="message-file" on:click={() => download(attachment.thumb_url)} src={attachment.thumb_url} width="100px" alt="thumb-nail" />
                                    <br/>
                                {/each}
                            {:else}
                                { message }
                            {/if}
                            <small>{ moment(new Date(created_at)).fromNow() }</small>
                        </p>
                    </li>
                    {:else }
                    <li class={`message left ${status.isSending ? 'sending' : ''} ${status.isFailed ? 'error' : ''}`}>
                        <img class="logo" src={user.image || chat.avatar()} alt="">
                        <p>
                            {#if attachments.length > 0}
                                {#each attachments as attachment}
                                    <img class="message-file" on:click={() => download(attachment.thumb_url)} src={attachment.thumb_url} width="100px" alt="thumb-nail" />
                                    <br/>
                                {/each}
                            {:else}
                                { message }
                            {/if}
                            <small>{ moment(new Date(created_at)).fromNow() }</small>
                        </p>
                    </li>
                    {/if}
                {/each}
            </ul>
        </div>
        <div class="form">
            <input 
                type="text" 
                id="message-input-feild" 
                class="text_input" 
                placeholder="Message..." 
                on:keyup={(e) => chat.sendMessage(e)}
                use:registerFocus
            />
            <span class="message-control">
                <span on:click={() => document.getElementById("attachment-input-feild").click()}>
                    <input type="file" id="attachment-input-feild" class="attachment" on:change={uploadFile}/>
                    <Icon icon="attachment" color={chat.loading ? '#0E99D2' : '#A7B4BE'} />
                </span>
            </span>
        </div>
    </div>
</div>

<style lang="scss">
    @import url('https://fonts.googleapis.com/css?family=Lato');
    #pannel {
        flex: 1;
        background: url('https://www.shutterstock.com/image-vector/social-media-sketch-vector-seamless-600nw-1660950727.jpg');
        background-size: cover;
        background-position: center	center;
        
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        font-family: 'Lato', sans-serif;
        margin: 0 0;
        height: 100%;
        overflow: hidden;
        .pannel-box {
            width: 100%;
            position: relative;
            .controls {
                top: 0;
                position: absolute;
                width: 100%;
                display: flex;
                justify-content: space-between;
                color: #fff;
                z-index: 1000;
                font-size: 10px;
                button {
                    color: white;
                    background-color: rgb(235, 12, 12);
                    border: none;
                    padding: 2px 10px;
                    border-radius: 1px;
                }
                span {
                    padding: 2px 10px;
                    font-size: 12px;
                    width: 50px;
                    overflow: hidden;
                }
            }
            .chat-container {
                background-color: rgba(0, 0, 0, 0.4);
                // border-radius: 25px;
                // box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.7);
                overflow: hidden;
                padding: 15px;
                position: relative;
                // width: 320px;
                height: 356px;
                max-width: 100%;
                width: 100%;
                .chat {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-start;
                    list-style-type: none;
                    padding: 0;
                    margin: 0;
                    overflow-y: scroll;
                    height: 100%;
                    -ms-overflow-style: none;  /* IE and Edge */
                    scrollbar-width: none;  /* Firefox */
                    &::-webkit-scrollbar {
                        display: none;
                    }
                    .message {
                        background-color: rgba(255, 255, 255, 0.9);
                        border-radius: 50px;
                        box-shadow: 0px 15px 5px 0px rgba(0,0,0,0.5);
                        position: relative;
                        margin-bottom: 15px;
                        font-size: 12px;
                        max-width: 100%;
                        &.sending {
                            background-color: rgba(210, 210, 210, 0.9);
                        }
                        &.error {
                            background-color: rgba(255, 210, 210, 0.9);
                        }
                        &.left {
                            padding: 10px 20px 10px 50px; //15px 20px 15px 70px;
                            small {
                                margin-left: 0.5rem;
                                color: #999;
                                font-size: 8px;
                            }
                        }
                        &.right {
                            align-self: flex-end;
                            padding: 10px 50px 10px 20px;
                            .logo {
                                left: auto;
                                right: 10px;
                            }
                            small {
                                margin-right: 0.5rem;
                                color: #999;
                                font-size: 8px;
                            }
                        }
                        .logo {
                            border-radius: 50%;
                            box-shadow: 0px 10px 10px 0px rgba(0,0,0,0.7);
                            object-fit: cover;
                            position: absolute;
                            left: 10px;
                            top: -10px;
                            width: 32px;
                            height: 32px;
                        }
                        p {
                            margin: 0;
                        } 
                        .message-file {
                            cursor: pointer;
                        }                  
                    }
                }
            }
            .form {
                position: relative;
                width: 100%;
                .text_input {
                    font-size: 16px;
                    position: relative;
                    // bottom: 0;
                    left: 0;
                    right: 0;
                    padding: 10px 15px;
                    padding-right: 40px;
                    width: 100%;
                    color: #666;
                }
                .message-control {
                    .attachment {
                        display: none;
                    }
                    position: absolute;
                    top: 6px;
                    right: 10px;
                }
            }
        }
    }
</style>